import Docs from "./Docs";

export default Docs;
